const contactForm = document.querySelector("#contact-us-form");
if (contactForm) {
  const formHoneyPot = contactForm.querySelector("#ContactForm-Email-Hidden");
  const submitBtn = contactForm.querySelector('button[type="submit"]');

  if (formHoneyPot) {
    formHoneyPot.addEventListener("input", () => {
      submitBtn.disabled = true;
    });
  }

  contactForm.addEventListener("submit", (e) => {
    e.preventDefault();
    contactForm.classList.remove("has-error-recaptcha");

    if (grecaptcha.getResponse() === "") {
      contactForm.classList.add("has-error-recaptcha");
      return;
    }

    if (submitBtn) {
      submitBtn.classList.add("loading");
    }

    const subjectField = contactForm.querySelector("#ContactForm-Subject");

    let formData;
    try {
      formData = JSON.stringify({
        contact: {
          subject: subjectField ? subjectField.value : "",
          first_name: contactForm.querySelector("#ContactForm-FirstName").value,
          last_name: contactForm.querySelector("#ContactForm-LastName").value,
          email: contactForm.querySelector("#ContactForm-email").value,
          phone: contactForm.querySelector("#ContactForm-Phone").value,
          body: contactForm.querySelector("#ContactForm-Message").value,
        },
      });
    } catch (error) {
      console.error("Error:", error);
      contactForm.classList.add("has-error");
      if (submitBtn) {
        submitBtn.classList.remove("loading");
      }
      return;
    }

    fetch("https://webhooks.mechanic.dev/74d3cfbb-af94-436b-b4e7-3fe75e3f5d0b", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }
        contactForm.classList.add("has-success");
        contactForm.reset();
      })
      .catch((error) => {
        console.error("Error:", error);
        contactForm.classList.add("has-error");
      })
      .finally(() => {
        if (submitBtn) {
          submitBtn.classList.remove("loading");
        }
      });
  });
}
